module.exports = __webpack_public_path__ + "static/eu-logo-f8a168b8550c3a22a470dcff7bd7efa4.svg";